import React from 'react';
import framework from 'utils/framework';
const { wrapFunctionalComponent } = framework;
import NthBrandsPage from 'components/Brand/NthBrandsPage';

const BrandNthCategory = () => <NthBrandsPage />;

export default wrapFunctionalComponent(BrandNthCategory, 'BrandNthCategory');
